import React from 'react';
import { PhoneOff, Video, Phone } from 'lucide-react';

const OutgoingCallScreen = ({ callData, onCancel }) => {
  const channelName = callData?.channel_name || 'Unknown';
  const isVideo = callData?.is_video;

  return (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-[#0F172A]" data-testid="outgoing-call-screen">
      <div className="text-center">
        {/* Pulsing avatar */}
        <div className="relative mx-auto w-28 h-28 mb-8">
          <div className="absolute inset-0 rounded-full bg-[#4338CA]/20 animate-ping" style={{ animationDuration: '2s' }} />
          <div className="absolute inset-2 rounded-full bg-[#4338CA]/10 animate-pulse" />
          <div className="relative w-28 h-28 rounded-full bg-[#4338CA] flex items-center justify-center text-white text-4xl font-bold">
            {channelName.charAt(0).toUpperCase()}
          </div>
        </div>

        <h2 className="text-white text-2xl font-bold mb-2" data-testid="outgoing-call-name">{channelName}</h2>
        <p className="text-white/50 text-sm mb-2">{isVideo ? 'Video Call' : 'Voice Call'}</p>

        {/* Animated "Calling..." dots */}
        <div className="flex items-center justify-center gap-1 mb-12">
          <span className="text-white/60 text-lg">Calling</span>
          <span className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-white/60 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <span className="w-1.5 h-1.5 bg-white/60 rounded-full animate-bounce" style={{ animationDelay: '200ms' }} />
            <span className="w-1.5 h-1.5 bg-white/60 rounded-full animate-bounce" style={{ animationDelay: '400ms' }} />
          </span>
        </div>

        {/* Cancel button */}
        <button
          onClick={onCancel}
          className="w-16 h-16 rounded-full bg-red-500 flex items-center justify-center mx-auto shadow-lg shadow-red-500/30 active:scale-90 transition-transform"
          data-testid="cancel-outgoing-call-button"
        >
          <PhoneOff className="text-white w-7 h-7" />
        </button>
        <p className="text-white/40 text-xs mt-3">Cancel</p>
      </div>
    </div>
  );
};

export default OutgoingCallScreen;
